import React from "react"
import { compose } from "recompact"
import { connect } from "react-redux"
import { requestValidate } from "src/engine/modules/validate/actions/creators"
import { selectViolationsList } from "src/engine/modules/validate/selectors"
import EventCard from "./EventCard"
import GroupCard from "./GroupCard"

// TODO упростить этот кошмар
// Сделать EventCard и GroupCard отдельными компонентами
export default compose(
  connect(
    state => ({
      planAllEventsValidate: selectViolationsList(state, `eventViolations`),
    }),
    dispatch => ({
      requestValidate: (...args) => dispatch(requestValidate(...args)),
    }),
  ),
)(props => (
  <div>
    {!props.groupCard ? <EventCard {...props} /> : <GroupCard {...props} />}
  </div>
))
